<template>
      <template v-for="(item, i) in mainMenuConfig" :key="i" >
        <div >
          <div class="menu-item">
            <div class="menu-content pt-2 pb-2">
              <div class="menu-section text-muted text-uppercase fs-8 ls-1 mb-3">
                เมนูพาร์ทเนอร์
              </div>
              <router-link
                  v-slot="{ href }"
                  :to="linkPrefix"
                >
                <h2 v-if="!!representPartner" >
                  <a 
                    :href="href"
                    class="text-dark" >
                    {{representPartner.partnerName}}
                  </a>
                </h2>
              
              </router-link>
            </div>
          </div>
          

          <div v-if="item.heading  " class="menu-item">
            <div class="menu-content pt-8 pb-2">
              <span class="menu-section text-muted text-uppercase fs-8 ls-1">
                {{ translate(item.heading) }}
              </span>
            </div>
          </div>
          <template v-for="(menuItem, j) in item.pages" :key="j">
            <template v-if="menuItem.heading">
              <div class="menu-item">
                <router-link
                  v-slot="{ href, navigate, isActive, isExactActive }"
                  :to="linkPrefix + menuItem.route"
                >
                  <a
                    :class="[isActive && 'active', isExactActive && 'active']"
                    :href="href"
                    class="menu-link"
                    @click="navigate"
                  >
                    <span
                      v-if="menuItem.svgIcon || menuItem.fontIcon"
                      class="menu-icon"
                    >
                      <i
                        v-if="asideMenuIcons === 'font'"
                        :class="menuItem.fontIcon"
                        class="bi fs-3"
                      ></i>
                      <span
                        v-else-if="asideMenuIcons === 'svg'"
                        class="svg-icon svg-icon-2"
                      >
                        <inline-svg :src="menuItem.svgIcon" />
                      </span>
                    </span>
                    <span class="menu-title">{{
                      translate(menuItem.heading)
                    }}</span>
                  </a>
                </router-link>
              </div>
            </template>
            <div
              v-if="menuItem.sectionTitle"
              :class="{ show: hasActiveChildren(menuItem.route) }"
              class="menu-item menu-accordion"
              data-kt-menu-sub="accordion"
              data-kt-menu-trigger="click"
            >
              <span class="menu-link">
                <span
                  v-if="menuItem.svgIcon || menuItem.fontIcon"
                  class="menu-icon"
                >
                  <i
                    v-if="asideMenuIcons === 'font'"
                    :class="menuItem.fontIcon"
                    class="bi fs-3"
                  ></i>
                  <span
                    v-else-if="asideMenuIcons === 'svg'"
                    class="svg-icon svg-icon-2"
                  >
                    <inline-svg :src="menuItem.svgIcon" />
                  </span>
                </span>
                <span class="menu-title">{{
                  translate(menuItem.sectionTitle)
                }}</span>
                <span class="menu-arrow"></span>
              </span>
              <div
                :class="{ show: hasActiveChildren(menuItem.route) }"
                class="menu-sub menu-sub-accordion"
              >
                <template v-for="(item2, k) in menuItem.sub" :key="k">
                  <div
                    v-if="item2.heading"
                    class="menu-item"
                  >
                    <router-link
                      v-slot="{ href, navigate, isActive, isExactActive }"
                      :to="linkPrefix + item2.route"
                    >
                      <a
                        :class="[isActive && 'active', isExactActive && 'active']"
                        :href="href"
                        class="menu-link"
                        @click="navigate"
                      >
                        <span class="menu-bullet">
                          <span class="bullet bullet-dot"></span>
                        </span>
                        <span class="menu-title">{{
                          translate(item2.heading)
                        }}</span>
                      </a>
                    </router-link>
                  </div>
                  <div
                    v-if="item2.sectionTitle"
                    :class="{ show: hasActiveChildren(item2.route) }"
                    class="menu-item menu-accordion"
                    data-kt-menu-sub="accordion"
                    data-kt-menu-trigger="click"
                  >
                    <span class="menu-link">
                      <span class="menu-bullet">
                        <span class="bullet bullet-dot"></span>
                      </span>
                      <span class="menu-title">{{
                        translate(item2.sectionTitle)
                      }}</span>
                      <span class="menu-arrow"></span>
                    </span>
                    <div
                      :class="{ show: hasActiveChildren(item2.route) }"
                      class="menu-sub menu-sub-accordion"
                    >
                      <template v-for="(item3, k) in item2.sub" :key="k">
                        <div
                          v-if="item3.heading"
                          class="menu-item"
                        >
                          <router-link
                            v-slot="{ href, navigate, isActive, isExactActive }"
                            :to="linkPrefix + item3.route"
                          >
                            <a
                              class="menu-link"
                              :class="[
                                isActive && 'active',
                                isExactActive && 'active',
                              ]"
                              :href="href"
                              @click="navigate"
                            >
                              <span class="menu-bullet">
                                <span class="bullet bullet-dot"></span>
                              </span>
                              <span class="menu-title">{{
                                translate(item3.heading)
                              }}</span>
                            </a>
                          </router-link>
                        </div>
                      </template>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </template>
        </div>
      </template>
  <!--end::Menu wrapper-->
</template>

<style lang="scss">
.aside-menu .menu .menu-sub .menu-item a a.menu-link {
  padding-left: calc(0.75rem + 25px);
  cursor: pointer;
  display: flex;
  align-items: center;
  flex: 0 0 100%;
  transition: none;
  outline: none !important;
}

.aside-menu .menu .menu-sub .menu-sub .menu-item a a.menu-link {
  padding-left: calc(1.5rem + 25px);
  cursor: pointer;
  display: flex;
  align-items: center;
  flex: 0 0 100%;
  transition: none;
  outline: none !important;
}
</style>

<script lang="ts">
import { defineComponent, onMounted, ref, reactive,computed, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import { version } from "@/core/helpers/documentation";
import { asideMenuIcons } from "@/core/helpers/config";
import MainMenuConfig, {getMenu, getUserMenu} from "@/core/config/MainMenuConfig";
import {role} from "@/helpers/role"

export default defineComponent({
  name: "kt-menu",
  components: {},
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const store = useStore();
    const scrollElRef = ref<null | HTMLElement>(null);
    onMounted(() => {
      ScrollComponent.reinitialization();
      MenuComponent.reinitialization();
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const currentUser = store.getters.currentUser;

    const selectPartner = computed(() => store.getters.getRepresentId);

    const linkPrefix = computed(() => "/partners/" + ( selectPartner.value == "" ? "" :  selectPartner.value ))

    // const currentRole = ref(store.getters.currentRole) 
    const currentRole = computed(() => store.getters.currentRole);
    
    const mainMenuConfig = reactive([...getUserMenu()])
    const representPartner = computed(() => store.getters.representPartner)
    

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    const hasActiveChildren = (match) => {
      const fullMatch = linkPrefix.value + match;
      return route.path === fullMatch || route.path.startsWith(fullMatch + '/');
    };

    const chackRole = (roles: string[]): boolean => {
      return !roles || !roles.length || roles.includes(currentRole.value);
    };

    return {
      hasActiveChildren,
      mainMenuConfig,
      asideMenuIcons,
      version,
      translate,
      chackRole,
      selectPartner,
      currentRole,
      linkPrefix,
      representPartner
    };
  },
});
</script>
